import Vue from 'vue'

export default {
  apiPrefix: '/api/v2/sites',
  getSiteDealer: function ({siteId}) {
    let apiDetailPath = this.apiPrefix + `/${siteId}/dealer`
    return Vue.http.get(Vue.env.apiPath + apiDetailPath, Vue.auth.getBearerHeader())
  },
}
